import { render, staticRenderFns } from "./IbxPassage.vue?vue&type=template&id=5c3469d2"
import script from "./IbxPassage.vue?vue&type=script&lang=js"
export * from "./IbxPassage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports